import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=5c367876&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=5c367876&prod&lang=scss"
import style1 from "./ProjectList.vue?vue&type=style&index=1&id=5c367876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c367876",
  null
  
)

export default component.exports